import React from 'react';
import {TextField, SelectField} from '../../FormFields/formFields';
import PersonalInfoActions from './PersonalInfoActions';
import PersonalInfoStore from './PersonalInfoStore';
import HeaderActions from '../../Header/HeaderActions';
import storage from 'storage';

export default class ChangeUsername extends React.Component {
	constructor(props) {
		super(props);
		this.setUsername = this.setUsername.bind(this);
		this.registerErrors = this.registerErrors.bind(this);
		this.isUsernameValid = this.isUsernameValid.bind(this);
		this.submitUsernameChange = this.submitUsernameChange.bind(this);
		this.registerErrors = this.registerErrors.bind(this);
		this.canSubmit = this.canSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.state = PersonalInfoStore.getState();
	}

	setUsername() {
		let name = readCookie('username');
		let tokenCookie = readCookie('token');
		if (tokenCookie) {
			let token = JSON.parse(tokenCookie);
			return token.sub;
		} else {
			return false;
		}
	}

	registerErrors() {
		this.refs.newUsername.isValid();
	}

	isUsernameValid() {
	    if (this.state.userName.length > 0 && !this.state.validUsername && this.refs.newUsername.isValid()) {
	        this.setState({
	            usernameExists: true
	    });
	    } 
		return this.state.validUsername;
	}

	componentDidMount() {
		PersonalInfoStore.listen(this.onChange);
	}

	componentWillUnmount() {
		PersonalInfoStore.unlisten(this.onChange);
	}

	onChange(state) {
	    this.setState(state);
	   
	}

	canSubmit() {
		return this.refs.newUsername.isValid(); 
	}

	registerErrors() {
		this.refs.newUsername.registerErrors();
	}

	submitUsernameChange() {
		if (this.canSubmit()) {
		    PersonalInfoActions.changeUsername(this.state.newUsername);
		    HeaderActions.logout();
			this.setState({ submitting: false });
			//this.props.cancelView('PersonalInfo');
		}
	}

	componentWillMount() {
		this.state = PersonalInfoStore.getState();
	}

    render() {
        let usernameErrorDisplay = this.state.usernameExists ?  <div
        className = "login-error-message" > { window.jenkon.resources["PWS.Enrollment.DesiredUsernameExistsMessage"] } </div>  :
        '';
        let validationRules = {
            Username: {
                required: true,
                requiredMessage: window.jenkon.resources["PWS.Enrollment.DesiredUsernameRequiredMessage"],
                username: true,
                usernameMessage: window.jenkon.resources["PWS.Enrollment.DesiredUsernameInvalidMessage"]
            },
        }

        return (
                        <div
        className = "login-form-area animate-in" >  < div
        className = "description" > { window.jenkon.resources['PWS.MyAccount.ChangeUsernameText'] } </div>
		<br/><br/>  < TextField
        ref = "CurrentUsername"
        disabled = { true }
        classes = "input-100"
        name = "Username"
        value = { this.state.userName } />  < div
        className = "input-100" >
            { usernameErrorDisplay } <TextField
        ref = "newUsername"
        name = "newUsername"
        classes = "input-bordered"
        handleChange = { PersonalInfoActions.changeField }
        Rules = { validationRules.Username }
        label = { window.jenkon.resources['PWS.MyAccount.NewUsername'] }
        value = { this.state.newUsername }
        handleKeyUp = { (e) => PersonalInfoActions.validateUsername(e.target.value) }/> 
		 </div>  
		 < button
        type = "button"
        className = "basic-submit-button"
        onClick={() => this.submitUsernameChange.call(this)}
    >{window.jenkon.resources["PWS.Globals.SaveChangesButton"]}</button>
                <button type="button" className="basic-submit-button" onClick={this.props.cancelView.bind(this, 'PersonalInfo')}>
					{window.jenkon.resources["PWS.Globals.CancelButton"]}</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/PersonalInfo/ChangeUserName.js